<script>
// Where content comes from, stated on the screen where people ask for it.
//
// Report Builder filters deliverables that are already tracked. When nothing
// is tracked yet — or nothing matches — the page used to say only "After
// applying some filters, your report will be generated here", which describes
// a step that cannot produce anything and offers no way out. The two routes
// below are the whole answer, and the second one is the one brands who already
// work with their creators need: it requires nothing from the influencer.
export default {
  name: "ReportContentSources",
};
</script>

<template>
  <div class="ui basic center aligned segment">
    <p>
      Report Builder pulls from content already being tracked on a campaign
      assignment. Content gets there two ways:
    </p>
    <div class="ui bulleted list report-content-sources">
      <div class="item">
        An influencer on the assignment adds it — the fullest stats, including
        private insights like reach and story taps.
      </div>
      <div class="item">
        You add it yourself — open the assignment and use
        <strong>Add content yourself</strong> to paste post URLs. No invite
        needed.
      </div>
    </div>
    <div>
      <a href="/influencer_hub" class="ui button basic" data-turbo="false">
        Go to campaigns
      </a>
    </div>
  </div>
</template>
